import { PulseApi } from 'api/PulseApi';
import { Pulse } from 'model/Pulse';
import dayjs from 'dayjs';

export class PulseMapper {
  deserialize({
    id,
    closedAt,
    startedAt,
    name,
    lifecycleType,
    sequenceNumber,
  }: PulseApi.Entry): Pulse {
    return {
      name,
      id,
      closedAt: dayjs(closedAt),
      startedAt: dayjs(startedAt),
      lifecycleType,
      sequenceNumber,
    };
  }
}
